import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from '@material-ui/core';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import usePasswordResetRequest from 'core/hooks/usePasswordResetRequest';
import useWelcomeMail from 'core/hooks/useWelcomeMail';
import { User } from 'core/types/user';
import { useSchemaMeta } from 'Elements/Form/Schema';

const TextWithButtons = styled.p`
  /* Align text and button texts to the same level vertically */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
`;

export default function UserActiveStatus() {
  const { user } = useSchemaMeta<{ user?: User }>();
  const { request, requesting } = usePasswordResetRequest();
  const { send, sending } = useWelcomeMail();
  const welcome = useCallback(() => user && send(user.id), [send, user]);
  const resetPassword = useCallback(() => {
    user && request(user.email);
  }, [request, user]);

  if (user === undefined) {
    return null;
  }

  return (
    <Card elevation={1}>
      <CardHeader title="Ongelmia kirjautumisessa?" />
      <CardContent>
        <Typography component={TextWithButtons}>
          Lähetä käyttäjälle{' '}
          <Button onClick={resetPassword} disabled={requesting}>
            Vaihda salasana
          </Button>{' '}
          tai{' '}
          <Button onClick={welcome} disabled={sending}>
            Tervetuloa
          </Button>{' '}
          sähköpostiviesti uudelleen.
        </Typography>
      </CardContent>
    </Card>
  );
}
